import React from "react";
import { Badge, ListGroup, ListGroupItem } from "reactstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import LayoutFullPage from "./layout-full-page";


const SideMenu = styled.div`
	padding: 20px 0;
	//width: 280px;
    font-size: 14px;

	.list-group-item {
		
		a {
			color: orange;
		}
	
		&.active {
			background-color: orange;
			border-color: orange;
			
			a {
				color: white;
			}
		}
	}
		
`;

const Menu = ({ router, pendingInvitations }) => (
	<SideMenu>
		<ListGroup flush>
			<ListGroupItem tag={Link} to={"/team/members"} active={router.location.pathname === "/team/members"} action>
				Team Members
			</ListGroupItem>
			<ListGroupItem tag={Link}
						   to={"/team/invitations"}
						   active={router.location.pathname === "/team/invitations"}
						   action>
				{"Invitations "} <Badge color="secondary" pill>{pendingInvitations}</Badge>
			</ListGroupItem>
		</ListGroup>
	</SideMenu>
);

const mapStateToProps = state => ({
	router: state.router,
	pendingInvitations: state.myTeam.content && state.myTeam.content.pendingInvitations.length
});

const ConnectedMenu = connect(
	mapStateToProps
)(Menu);

const LayoutTeamPage = ({ children }) => (
	<LayoutFullPage Menu={ConnectedMenu}>
		{children}
	</LayoutFullPage>
);

export default LayoutTeamPage;
